import { ReactElement, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

import { Timeout } from '@utils/types';

export const useRenderedDimensions = (
  renderFunction: () => ReactElement,
  dependencyArray: Array<any>,
) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const timeoutRef = useRef<Timeout>();

  useEffect(() => {
    const container = document.createElement('div');
    container.style.position = 'absolute';
    container.style.visibility = 'hidden';
    container.style.pointerEvents = 'none';

    document.body.appendChild(container);
    ReactDOM.render(renderFunction(), container);

    timeoutRef.current = setTimeout(() => {
      const { offsetWidth: width, offsetHeight: height } = container;
      setDimensions({ width, height });
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
    });

    return () => clearTimeout(timeoutRef.current);

    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, dependencyArray);

  return dimensions;
};
